import { useMutation } from "@tanstack/react-query";
import { createUser } from "../../../api/requests/createUser";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useCreateUser = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: createUser,
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
